import { PlusIcon } from '../../../icons/Icons'
import { getLineColor } from './common'
import { CSSProperties, useState } from 'react'
import { cn } from '@dashboard/ui'

interface PlusButtonProps {
  id: string
  transform?: string
  onClick: (target: EventTarget & HTMLDivElement) => void
  color?: string
  style?: CSSProperties
  visible?: boolean
}

const PlusButton: React.FC<PlusButtonProps> = ({ id, style, transform, onClick, color, visible }) => {
  let clr = color || getLineColor()

  const [isHovered, setIsHovered] = useState(false)
  const handleMouseEnter = () => {
    setIsHovered(true)
  }
  const handleMouseLeave = () => {
    setIsHovered(false)
  }
  return (
    <div
      className={cn(
        'pointer-events-auto absolute flex size-[24px] cursor-pointer items-center justify-center rounded-full bg-fg-primary transition-all duration-100 ease-in-out hover:size-[24px] hover:bg-fg-primary',
        !visible && 'size-[8px] bg-fg-brand-primary',
      )}
      id={id}
      style={{
        transform: transform,
        ...style,
        border: `1px solid ${clr}`,
        boxShadow: isHovered ? `0 1px 12px 0 ${clr}` : 'none',
      }}
      onMouseDown={e => e.stopPropagation()}
      onClick={e => onClick(e.currentTarget)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <PlusIcon style={{ color: color || '#0097E4' }} />
    </div>
  )
}

export default PlusButton
